/**
 * Returns true if the subject is a date
 * @param subject
 */
export default function isDate(subject) {
    return subject instanceof Date;
}
